import httpRequest, { ApiConfig } from 'httpRequest'
import { LocationSubDomainInfo } from 'models'

const TENANT_PREFIX = '/tenant'

const cloudTenentService = {
    getSubDomain: (config?: ApiConfig) =>
        httpRequest.get<LocationSubDomainInfo[]>(
            TENANT_PREFIX + '/sub-domain',
            config,
        ),
}

export default cloudTenentService
